(() => {
  const initialize = () => {
    document.querySelectorAll('.hdx-system').forEach((section) => {
      const form = section.querySelector('.hdx-system__purchase form');
      const button = form?.querySelector('button[type="submit"]');
      const errorMessage = form?.querySelector('[data-hdx-system-cart-error]');
      if (!form || !button || form.dataset.hdxCartInitialized) return;
      form.dataset.hdxCartInitialized = 'true';

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (button.disabled) return;

        const variantId = Number(new FormData(form).get('id'));
        if (!variantId) return;

        const originalLabel = button.textContent;
        const root = window.Shopify?.routes?.root || '/';
        const cartUrl = window.theme?.routes?.cart || `${root}cart.js`;
        const addUrl = window.theme?.routes?.cartAdd || `${root}cart/add.js`;
        button.disabled = true;
        button.textContent = section.dataset.hdxSystemAdding || originalLabel;
        button.setAttribute('aria-busy', 'true');
        if (errorMessage) errorMessage.hidden = true;

        try {
          const cartResponse = await fetch(cartUrl, { credentials: 'same-origin' });
          if (!cartResponse.ok) throw new Error('Cart could not be loaded');
          const cart = await cartResponse.json();
          const alreadyInCart = cart.items.some((item) => Number(item.variant_id) === variantId);

          if (alreadyInCart) {
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));
          } else {
            const addResponse = await fetch(addUrl, {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: 1 })
            });
            if (!addResponse.ok) throw new Error('Program could not be added');
            const product = await addResponse.json();
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product, form } }));
          }
        } catch (error) {
          if (errorMessage) errorMessage.hidden = false;
        } finally {
          button.disabled = false;
          button.textContent = originalLabel;
          button.removeAttribute('aria-busy');
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
